import { createReducer, on, Action } from '@ngrx/store';
import * as actions from './order-types.actions';

const initialState: OLO.State.OrderTypes = {
    isDownloading: false,
    hasFailed: false,
    hasSucceeded: false,
    data: null,
};

export const orderTypesReducerFn = createReducer(
    initialState,
    on(actions.OrderTypesRequest, (state) => ({
        ...state,
        isDownloading: true,
        hasFailed: false,
        hasSucceeded: false,
        data: null,
    })),
    on(actions.OrderTypesSuccessRequest, (state, action) => ({
        ...state,
        isDownloading: false,
        hasFailed: false,
        hasSucceeded: true,
        data: action.payload,
        downloadedDate: Date.now(),
    })),
    on(actions.OrderTypesErrorRequest, (state) => ({
        ...state,
        isDownloading: false,
        hasFailed: true,
        hasSucceeded: false,
    })),
);

export function orderTypesReducer(state: OLO.State.OrderTypes | undefined, action: Action) {
    return orderTypesReducerFn(state, action);
}
